import apiClient from '../../../services/session/apiClient'

export function searchPlaces(params){
  return apiClient.get('/places/search',{params})
}
